import React, { Component } from 'react';
import moment from 'moment';
import RavenUtil from '../../common/ravenUtil';
import { ModalLoadingPage } from '../../common/loadingPage';
import { strings } from '../../../localization';

export default class TripSharingSidebar extends Component {

    constructor(props) {

        super(props);

        this.state = {
        }
    }

    render() {

        // console.log('tripsharing sidebar state: ', this.state, 'props: ', this.props);
        var ravenLabel = this.props.raven.vehicle && this.props.raven.vehicle.name ? this.props.raven.vehicle.name : "Raven";
        var route = this.props.raven.dashboard.route ? this.props.raven.dashboard.route : this.props.raven.dashboard.route ? this.props.raven.dashboard.route : null;
        var searchForGpsLabel = null;
        var drivingLabel = null; //used as trip started label when car is parked mid-trip
        var parkedLabel = null; //shown while trip has started but are currently parked.
        if (route) {
            if (route.length > 1 &&
                (!route[1].lat || !route[1].lon)
            ) {
                searchForGpsLabel = <p><i className="material-icons">my_location</i>{strings.formatString(strings.db_raven_searching_gps)}</p>;
            }
            if (route.length === 0) {
                searchForGpsLabel = <p><i className="material-icons">my_location</i>{strings.formatString(strings.db_raven_searching_gps)}</p>;
            }

            var startDate = route.length > 1 ? route[1].ts : route.length > 0 ? route[0].ts : null;
            if (startDate && this.props.raven.dashboard.status && this.props.raven.dashboard.status.toLowerCase() === 'parked') {
                drivingLabel = <p><i className="material-icons">local_parking</i>{strings.formatString(strings.db_raven_parked_label, moment(RavenUtil.convertTs(startDate)).format('MMMM Do[,] h:mm a'))}</p>;
            } else if (startDate && this.props.raven.dashboard.status && this.props.raven.dashboard.status.toLowerCase() !== 'parked') {
                drivingLabel = <p><i className="material-icons">directions_car</i>{strings.formatString(strings.db_raven_driving_label, moment(RavenUtil.convertTs(startDate)).format('MMMM Do[,] h:mm a'))}</p>;
            } else if (startDate === null && route.length === 1) {
                drivingLabel = <p><i className="material-icons">local_parking</i>{strings.formatString(strings.db_raven_parked_label, moment(RavenUtil.convertTs(this.props.raven.start.ts)).format('MMMM Do[,] h:mm a'))}</p>;
            } else {
                parkedLabel = <p><i className="material-icons">local_parking</i>{strings.formatString(strings.db_raven_is_parked_label, ravenLabel)}</p>;
            }

            //if parked but was driving
            if (route.length > 1 && this.props.raven.dashboard.status && this.props.raven.dashboard.status.toLowerCase() === 'parked') {
                drivingLabel = <p><i className="material-icons">navigation</i>{strings.formatString(strings.db_raven_trip_started_label, moment(RavenUtil.convertTs(startDate)).format('MMMM Do[,] h:mm a'))}</p>;
                parkedLabel = <p><i className="material-icons">local_parking</i>{strings.formatString(strings.db_raven_is_parked_label, ravenLabel)}</p>
            }
        }

        //live feed TODO placeholder until we get continual images
        var previewBtnClasses = ["btn", "btn-icon", "btn-bottom-right-corner"];
        if (this.props.lookingForPreview) previewBtnClasses.push("loading");
        var liveFeedSection = <div className="row live-feed">
            <div className="col-12">
                <ModalLoadingPage message={strings.formatString(strings.db_live_feed_loading)} />
            </div>
        </div>

        if (this.props.raven.preview) {
            liveFeedSection = (
                <div className="row live-feed">
                    <div className="col-12">
                        <div className="img-wrapper">
                            <img src={"data:image/png;base64," + this.props.raven.preview} alt="live-feed-image" />
                            <div className="timestamp-label">{moment(RavenUtil.convertTs(this.props.raven.previewTs)).format('LTS')}</div>
                            <button className={previewBtnClasses.join(" ")} onClick={this.props.onGetNewImage} title={strings.formatString(strings.btn_get_new_image)}>
                                <i className="material-icons">refresh</i>
                            </button>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="trip-sharing-wrapper">
                <div className="row raven-details">
                    <div className="col-12 raven-details-info">
                        <div className="row">
                            <div className="col-12 raven-title">
                                <h2>{ravenLabel}</h2>
                                {this.props.raven.currentDriver ? (
                                    <h3>{strings.formatString(strings.driving_label, this.props.raven.currentDriver)}</h3>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
                {liveFeedSection}
                <div className="row raven-details">
                    <div className="col-12 raven-details-info">
                        <div className="row">
                            <div className="col-12 raven-status">
                                {searchForGpsLabel}
                                {drivingLabel}
                                {parkedLabel}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
